export default __webpack_public_path__ + "static/media/star.e81cd6e7.mp4";